import type {ReactElement} from 'react';
import styles from './pending-reply-loader.module.scss';
import {PmwLogo} from '@Components/ai-chat-window/components/pmw-logo/pmw-logo';
import {CyclingLoadingText} from '@Components/ai-chat-window/components/cycling-loading-text/cycling-loading-text';
import {getReconnectingLoadingTexts} from './pending-reply-loader.library';

/**
 * The row shown while a reply is still being produced but nothing of it has arrived yet — the state
 * a page reload lands in when the turn is already running. Shared so the trailing user message and a
 * recovered assistant message show the same thing.
 */
export function PendingReplyLoader(): ReactElement {
  return (
    <div className={styles.pendingReplyRow}>
      <PmwLogo className={styles.pendingReplyLogo} animated />
      <CyclingLoadingText loadingTexts={getReconnectingLoadingTexts()} />
    </div>
  );
}
